import 'css-chunksrc/client/scenes/assignToTask/projectSelection/loader/styles.scss';export default {
  "loader": "_loader_1wdwm_1",
  "item": "_item_1wdwm_5",
  "checkbox": "_checkbox_1wdwm_15",
  "name": "_name_1wdwm_23"
};